<template>
  <div class="form-check form-switch">
    <label class="form-check-label" :class="labelClass" :for="id">
      <slot />
    </label>
    <input
      :id="id"
      class="form-check-input"
      :class="$attrs.class"
      type="checkbox"
      :name="name"
      :checked="checked"
      @change="$emit('change', $event)"
    />
  </div>
</template>

<script>
export default {
  name: "SoftSwitch",
  props: {
    name: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    labelClass: {
      type: String,
      default: "",
    },
  },
  emits: ["change"],
};
</script>
<style scoped>
.form-check {
  padding-left: 0 !important;
}
</style>